import KeySecurityOverview from './KeySecurityOverview'

export { KeySecurityOverview }
export default KeySecurityOverview
